import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ImportService } from '../../Modules/Renewal_Manager/Services/import.service';
import { AuthService } from '../Services/auth.service';

export const authGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> | boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const importService = inject(ImportService);

  // 1. Check basic auth first
  if (!authService.isAuthenticated()) {
    return router.parseUrl('/login');
  }

  // 2. Handle the async logic reactively
  // Assuming getLastUploadedDate is an Observable/BehaviorSubject
  return authService.getLastUploadedDate.pipe(
    take(1), // Ensure the guard completes after the first value
    map(date => {
      // if (date) {
        // Logic for redirection
      if (state.url === '/step-guide') {
        return true;
      }
        if (state.url !== '/import' && !date) {
          return router.parseUrl('/import');
        }
      // }

      return true; // Allow navigation if no redirects trigger
    })
  );
};
